// FLY'S READY SCREEN — the one step a person who signed up through Fly meets on
// the welcome's setup surface (components/OnboardingWizard.js;
// functions/onboardingReady.js tells who, what and when it writes; Nika
// 2026-10-25: "Short ready screen (Recommended)"). Fly asked the three
// questions already, so this is not a wizard: the surface's title says the
// workspace is ready, its lead says Fly set it up with the person, and the
// step lists what is ready — the workspace's apps and its website project —
// then the two ways on: Start working (a plain close) and the quick tour.
//
// All of it is the wizard's own: the shell, the studio beside it, the title
// and lead, the setup lines (OnboardingSetupLine — the apply's lines of Your
// apps, here a name and a tick), the way row (OnboardingWay — the welcome's tour
// offer) and the brand's primary capsule. Every value comes from
// functions/onboardingReady.js through `el.call`; every factory names the root
// key it follows (`…Deps`). The facts are frozen in the flow when the surface
// opens, so nothing arrives under a reading person (Rule 66).

// THE STEP — what is ready, Start working, the tour.
export const OnboardingReadyStep = {
  extends: 'OnboardingWizardStep',
  wizardStep: 'ready',

  OnboardingReadyMade: {},

  // A plain close: Escape's own path (closeOnboarding 'close' decides done,
  // via 'fly', because the screen showed).
  ReadyStart: {
    display: 'flex',
    minWidth: '0',
    AppCapsuleBtnPrimary: {
      width: '100%',
      padding: 'A B',
      text: '{{ workspace.onboarding.chat.finish | polyglot }}',
      onClick: (e, el) => {
        e.stopPropagation()
        el.call('closeOnboarding', 'close')
      }
    }
  },

  // The tour offer — the welcome's own row (OnboardingWay → onboardingChoose
  // 'tour': decides done, via 'tour', closes, starts the tour).
  ReadyWays: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'Y',
    minWidth: '0',
    OnboardingWay_tour: {
      way: 'tour',
      icon: 'playOval',
      heading: 'workspace.onboarding.wayTour',
      hint: 'workspace.onboarding.wayTourHint'
    }
  }
}

// WHAT IS READY — the wizard's captioned group (OnboardingWizardGroup: its
// caption sits under the step's title), then ONE list of setup lines
// (OnboardingLineList, the apply's own list): the apps (their glyph, their name
// and the plain tick) and the website project last, and a quiet "N more apps"
// under it past six. Hidden when Fly made nothing the screen can
// name: the title and the lead still say the workspace is ready.
export const OnboardingReadyMade = {
  extends: 'OnboardingWizardGroup',
  caption: 'workspace.onboarding.ready.made',
  hideDeps: [(el, s) => s.root && s.root._onboardingFlow],
  hide: (el, s) => !(el.call('onboardingReadyView', s.root) || {}).show,

  OnboardingLineList: {
    childrenDeps: [(el, s) => s.root && s.root._onboardingFlow],
    children: (el, s) => (el.call('onboardingReadyView', s.root) || {}).rows || []
  },

  ReadyMore: {
    tag: 'p',
    margin: '0',
    fontSize: 'Z',
    lineHeight: '1.5',
    color: 'inactive',
    hideDeps: [(el, s) => s.root && s.root._onboardingFlow],
    hide: (el, s) => !(el.call('onboardingReadyView', s.root) || {}).moreText,
    textDeps: [(el, s) => s.root && s.root._onboardingFlow],
    text: (el, s) => (el.call('onboardingReadyView', s.root) || {}).moreText || ''
  }
}
